export default {
    lang: {
        LoadMore: 'Carregar mais',
        AllLoaded: 'Tudo carregado',
        ChangeLanguage: 'Alterar idioma',
        ChangePassword: 'Alterar senha',
        copy: 'Cópia',
        copySuccess: 'Cópia bem-sucedida',
        copyError: 'Falha na cópia',
        CopyEmptyTips: 'O conteúdo a ser copiado não pode estar vazio',
        empty: 'Vazio aqui',
        tips: 'Dicas',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        more: 'Mais',
        isCloseGame: 'Deseja fechar o jogo?',
        back: 'Voltar',
        Claim: 'Resgatar',
        Loading: 'Carregando',
        Play: 'Jogar',
        Download: 'Baixar',
        NoData: 'Ops! Ainda não há dados!',
        NoMore: 'Não há mais',
        CurrentlyPage: 'Atualmente nesta página',
        keywordPlaceholder: 'Por favor, insira o nome do jogo que deseja pesquisar!',
        SearchGameByName: 'Pesquisar o nome do jogo'
    },
    tabbar: {
        menu: 'menu',
        Lobby: 'Início',
        Earn: 'Compartilhar',
        Game: 'Jogo',
        Event: 'Evento',
        Promotion: 'Promoção',
        Account: 'Perfil',
        Recharge: 'Recarregar',
        serve: 'Atendimento',
        Deposit: 'Depósito',
        Affiliate: 'Afiliado'
    },
    home: {
        Download: 'Baixar',
        DownloadTips: 'Baixe o aplicativo e ganhe ',
        Search: 'Pesquisar',
        SearchGames: 'pesquisa',
        Popular: 'Populares',
        Recent: 'Recentes',
        Favorite: 'Favoritos',
        Providers: 'Provedores',
        CollectionSucc: 'Coleção bem-sucedida',
        CollectionCanceled: 'Coleção cancelada',
        MORE: 'MAIS',
        Top: 'Topo',
        greatBonus: 'Excelente Bônus para Depósito',
        pullRefresh: 'Arraste para baixo para atualizar...',
        releaseRefresh: 'Solta para atualizar...',
        loading: 'carregando...',
        gameMoreTips1: 'A exibir ',
        gameMoreTips2: ' jogos entre ',
        gameMoreTips3: ' jogos'
    },
    login: {
        Login: 'Entrar',
        SignIn: 'Signar',
        SignUp: 'Cadastrar-se',
        RememberMe: 'Lembrar de mim',
        ForgetPassword: 'Esqueceu a senha?',
        LoginTips: 'Para acessar este site, certifique-se de ter mais de 18 anos e concordar?',
        TermsOfService: 'Termos de Serviço',
        jumpRegister: 'Ir para cadastro',
        JumpLogin: 'Ir para login',
        noAccountTips: 'Não tem uma conta?',
        hasAccountTips: 'Já tem uma conta?',
        Email: 'E-mail',
        VerificationCode: 'Código de verificação',
        Send: 'Enviar',
        RestPassword: 'Redefinir senha',
        passwordTips: 'Senha (6-16 caracteres)',
        passwordTips2: 'Insira a senha novamente',
        password: 'Senha',
        phone: 'Número de telefone',
        ReferralCode: 'Código de indicação',
        CreateAccount: 'Criar conta',
        PleaseEnterYourPhoneNumber: 'Por favor, insira seu número de telefone',
        PleaseEnterYourPassword: 'Por favor, insira sua senha',
        ThePasswordMustContain6To16Characters: 'A senha deve conter de 6 a 16 caracteres',
        InconsistentPassword: 'As senhas não coincidem',
        PleaseEnterInvitationCode: 'Por favor, insira o código de convite',
        PleaseEnterEmail: 'Por favor, insira sua conta de e-mail',
        PleaseEnterEmailFormat: 'Por favor, insira o formato de e-mail correto',
        day: 'dia',
        also: 'também',
        downTime: 'Data desde o lançamento',
        changePwd: 'Alterar senha',
        RechargeNow: 'Recarregar Agora',
        PlayGame: 'Cadastro bem-sucedido! Jogar um jogo~',
        serviceTips: 'Primeiro, concorde com os termos de serviço',
        SuccessfullyClaimed: 'Resgatado com sucesso',
        SuccessfullyClaimedTips1: '',
        SuccessfullyClaimedTips2: ' bônus será creditado na conta',

        Account: 'Conta',
        PleaseEnterAccount: 'Por favor, insira a conta',
        AccountFormat: 'Formato de conta inválido: 6-16 caracteres, aceita letras inglêsas/números',
        PhoneFormat: 'O formato do número de telefone inserido está incorreto',
        PleaseEnterPassword: 'Por favor, insira a senha',
        PasswordFormat: 'Pelo menos 6 caracteres',
        ConfirmPassword: 'Confirmar senha',
        ConfirmPwdAgain: 'Confirmar senha novamente',
        InvitationCode: 'Código de convite',
        PleaseEnteryourInvitationCode: 'Por favor, insira seu código de convite',
        OverAgeAgree: 'Tenho mais de 18 anos, li e aceito',
        PleaseAgreeOverAge: 'Primeiro, marque o termo de aceite',
        RememberYouraccountPassword: 'Lembrar conta e senha',
        SelectCountry: 'Idioma',

        Reminder: 'Lembrete',
        WantLogOutAccount: 'Deseja sair da sua conta?',
        ConfirmExit: 'Confirmar saída',
        Cancel: 'Cancelar',

        Strength: 'Força',
        sixteenDigits: '8-16 dígitos',
        UpperCaseletters: 'Letras maiúsculas',
        LowerCaseLetters: 'Letras minúsculas',
        Numbers: 'Números',

        UNLOCK: 'DESBLOQUEAR',
        ENDLESSBENEFITS: 'BENEFÍCIOS INFINITOS',
        loginTips1: 'Bônus generosos estão prontos! Junte-se a nós e encontre seus tesouros!',
        loginTips2: 'Evento VIP Exclusivo: Aposte e Ganhe Oportunidades',
        loginTips3: 'Envelope vermelho, pagamento diário regular',
        loginTips4: 'Benefícios ao convidar amigos para obter baús de tesouros.',
        loginTips5: 'Benefícios ao fazer login diariamente',
        loginTips6: 'Na primeira recarga, você pode receber um bônus de até 20%.',
        loginTips7: 'Suba de nível VIP para receber bônus',
        loginTips8: 'Bem-vindo ao ',
        loginTips9: 'TRAZ uma experiência de jogo sem precedentes',
        accountOrPhone: 'Conta / Número de Telefone'
    },
    logout: {
        SignOut: 'Sair',
        SignOutTips: 'Explore um mundo cheio de recompensas e jogos emocionantes!'
    },
    signin: {
        signInTitle: 'Bônus de Registro Diário',
        signInDays: 'Registrado consecutivamente por ',
        days: ' dias',
        day: 'DIA',
        claimed: 'Resgatado ',
        condition1: 'Depósito necessário',
        condition2: 'Apostas necessárias',
        eventDetails: 'Detalhes do Evento',
        checkin: 'Registrar',
        CheckIn: 'REGISTRAR',
        Today: 'Hoje',
        Uncompleted: 'INCOMPLETO',
        Completed: 'COMPLETO',
        Conditions: 'Condições',
        Rules: 'Rules',
        titleTips: 'actual, has been received during',
        Recarregue: 'Recharge',
        Aposte: 'Aposte',
        desc1: 'The current level can log in with a total of',
        desc2: 'days and receive',
        upBonusTitle: 'Parabens por receber um bonus diario de',
        upBonusDesc1: 'Basta depositar',
        upBonusDesc2: 'para aumentar sua recompensa em',
        upBonusDesc3: 'vezes',
        upBonusGetNow: 'Receba agora',
        upBonusGet: 'Receba',
        upBonusRedeemSuccess: 'Resgate concluido',
        upBonusRedeemMessage: 'receber',
        upBonusConfirm: 'Confirmar',
        navTitle: 'Check-in',
        buttonCheckIn: 'Check-In',
        continua: 'continúa mañana',
        Coleta: 'Coleta contínua',
        recompensas: 'Obter recompensas',
        Tempo: 'Tempo',
        buttonUnavailable: 'Nao atende as condicoes'
    },
    share: {
        panel: 'Painel',
        FAQ: 'Dúvidas Frequentes',
        TUTORIAL: 'TUTORIAL',
        TotalRewards: 'Recompensas Totais',
        TotalFriends: 'Total de Amigos',
        inviteFriend: 'CONVIDE AMIGOS PARA GANHAR',
        signUp: 'Cadastre-se e Ganhe',
        Commission: 'Comissão',
        InviteVia: 'Convidar por:',
        copy: 'Copiar',
        link: 'Link',
        code: 'Código',
        or: 'OU',
        Rewards: 'Recompensas',
        title1: 'COMISSÃO',
        tip1: 'Ganhe até',
        tip2: 'de comissão quando seu amigo apostar.',
        title2: 'REEMBOLSO DE DEPÓSITO',
        tip3: 'Ganhe',
        tip4: 'quando seu amigo fizer depósito.',
        Details: 'Detalhes',
        UncollectedCommissions: 'Comissões não resgatadas',
        ExclusiveCommission: 'Comissão Exclusiva',
        DepositCashback: 'Reembolso de Depósito',
        Claim: 'Resgatar',
        TodayTeamData: 'Dados da equipe hoje',
        TotalTeamData: 'Dados totais da equipe',
        SignUp: 'Cadastro',
        FirstDeposit: 'Primeiro Depósito',
        ValidBet: 'Aposta Válida',
        LiveRewards: 'Recompensas ao Vivo',
        SendTotalCommission: 'Enviar comissão total',
        rules: 'Regras',
        ruleInfo: 'Você pode ganhar dinheiro indicando amigos e ganhar até recompensas de comissão!',
        Recommended: 'Recomendado',
        Month: 'Mês',
        UnlimitedSubordinates: 'Desenvolvimento ilimitado de subordinados',
        planTitle: 'SAIBA MAIS SOBRE NOSSO PROGRAMA DE AFILIADOS',
        planInfo: 'Se você tiver uma grande audiência e seguidores, temos condições especiais para personalizar seu programa de indicação!',
        all: 'Todos',
        Direct: 'Diretos',
        Indirect: 'Indiretos',
        TodayTeamIntro1: 'Cadastro: Número de usuários que se cadastraram hoje',
        TodayTeamIntro2: 'Primeiro Depósito: Número de usuários que fizeram o primeiro depósito hoje',
        TodayTeamIntro3: 'Apostas Válidas: Apostas válidas da equipe hoje',
        TotalTeamIntro1: 'Cadastro: Número total de cadastros da equipe',
        TotalTeamIntro2: 'Primeiro Depósito: Número total de primeiros depositantes',
        TotalTeamIntro3: 'Apostas Válidas: Valor total de apostas válidas da equipe',
        calculationRules: 'Regras de cálculo de comissão',
        rewardRules: 'Regras de recompensa de comissão',
        ExtendRewardsBouns: 'Bônus de Recompensas Estendidas',
        GameBettingRewardsBouns: 'Bônus de Recompensas de Apostas em Jogos',
        RechargeRewardsBouns: 'Bônus de Recompensas de Recarga',
        Tier: 'Nível',
        intro1: 'Cadastro: Número de usuários que se cadastraram hoje',
        intro2: 'Primeiro Depósito: Número de usuários que fizeram o primeiro depósito hoje',
        intro3: 'Apostas Válidas: Apostas válidas da equipe hoje',
        intro4: 'Cadastro: Número total de cadastros da equipe',
        intro5: 'Primeiro Depósito: Número total de primeiros depositantes',
        intro6: 'Apostas Válidas: Valor total de apostas válidas da equipe',
        rule1: 'Toda vez que o jogador indicado por você fizer uma aposta, ganhar ou perder, você receberá uma porcentagem de comissão diferente.',

        startTime: 'início',
        endTime: 'fim',
        TotalRewardAmount: 'Valor total de recompensas:',
        level: 'nível',
        Amount: 'valor',
        NumberOfPeople: 'Número de pessoas',
        Part1Blogger: 'Recompensas para usuários',
        FirstRewardAmount: 'Valor de recompensa para membros de primeiro nível',
        FirstNumberOfPeople: 'Número de membros válidos de primeiro nível',
        FirstRewardRatio: 'Taxa de recompensa para membros válidos de primeiro nível',
        FirstPaymentDiff: 'Diferença de pagamento de membros de primeiro nível',
        FirstRechargeAmount: 'Valor de recarga para membros de primeiro nível',
        FirstWithdrawalAmount: 'Valor de saque para membros de primeiro nível',
        Part2Partners: 'Recompensas para parceiros',
        PartnerRewardAmount: 'Valor de recompensa para parceiros:',
        PartnerRechargeAmount: 'Valor de recarga do parceiro:',
        PartnerWithdrawalAmount: 'Valor de saque do parceiro:',
        FirstEffectiveNumber: 'Número eficaz de parceiros de primeiro nível',
        SecondNumberOfPeople: 'Número de membros válidos de segundo nível',
        FirstPartnersRewardRatio: 'Taxa de recompensa para parceiros de primeiro nível',
        FirstPartnersRewardAmount: 'Valor de recompensa para parceiros de primeiro nível',
        FirstPartnersPaymentDiff: 'Diferença de pagamento do parceiro de primeiro nível',
        SecondEffectiveRechargeAmount: 'Valor de recarga eficaz para membros de segundo nível',
        SecondEffectiveWithdrawalAmount: 'Valor de saque eficaz para membros de segundo nível',
        SecondRechargeAmount: 'Valor de recarga para membros de segundo nível',
        SecondWithdrawalAmount: 'Valor de saque para membros de segundo nível',
        partnerRulesTips1_1: 'Aumente as recompensas de indicação e a participação de lucros dos indicadores. O blogueiro A indica o blogueiro B, e A ganha ',
        partnerRulesTips1_2: ' do lucro de B',
        partnerRulesTips1_3: '',
        partnerRulesTips2_1: 'As regras de parceria exigem liquidação ',
        partnerRulesTips2_2: 'uma vez ao dia. ',
        partnerRulesTips2_3: 'uma vez por semana. ',
        partnerRulesTips2_4: 'uma vez por mês. ',
        partnerRulesTips2_5: 'Fazer a primeira recarga conta como membro válido',
        partnerRulesTips2_6: 'Recarregar ',
        partnerRulesTips2_7: ' e fazer uma aposta de ',
        partnerRulesTips2_8: ' para ser considerado membro válido',
        ReachStandard: 'Número de pessoas que atendem ao padrão',
        RewardRatio: 'Taxa de recompensa',
        partner: 'Parceiro',
        LowerLevelTeamData: 'Dados da equipe de nível inferior',
        allData: 'Todos os Dados',
        yesterday: 'Ontem',
        today: 'Hoje',
        thisWeek: 'Esta Semana',
        lastWeek: 'Semana Passada',
        thisMonth: 'Este Mês',
        lastMonth: 'Mês Passado',
        validBets: 'Apostas Válidas',
        deposit: 'Depósito',
        myData: 'Meus Dados',
        newSubordinates: 'Novos subordinados',
        firstDeposits: 'Primeiros Depósitos',
        firstDepositAmount: 'Valor do primeiro depósito',
        deposits: 'Depósitos',
        withdrawalValue: 'Valor do Saque',
        ValidBets: 'Apostas Válidas',
        receiveBonuses: 'Receber bônus',
        performance: 'Desempenho',
        GLV: 'Valor de ganho/perda',
        commission: 'Comissão',
        dataSummary: 'Resumo de dados',
        agentDataTip: 'Resumo dos dados de hoje após se tornar um agente',
        teamSize: 'Tamanho do time',
        directMembers: 'Membros Diretos',
        OtherMembers: 'Outros Membros',
        fullPerformance: 'Desempenho total',
        direct: 'D. Direto',
        others: 'D. dos Outros',
        totalCommissions: 'Comissões Totais',
        directCommission: 'Comissão Direta',
        otherCommission: 'Outra Comissão',
        totalCommission: 'Comissão Total',
        rescued: 'Resgatado',
        notCollected: 'Não recolhido',
        directDepositTotal: 'Total de depósito do subordinado direto',
        directSubordinateWithdrawalsTotal: 'Total direto dos saques do subordinado',
        directOrdersTotal: 'Total de pedidos do subordinado diretos',
        directValidBetsTotal: 'Total de apostas válidas do subordinado direto',
        directGainToatl: 'Lucro e perda direta acumulada',
        DirectRechargeAmount: 'Total de recargas diretas',
        OtherDeposits: 'Outro Depósito',
        FirstDirectRecharge: 'Primeira recarga direta',
        OtherInitialRefills: 'Outras recargas iniciais',
        TotalFirstDepositsPlayers: 'Total de jogadores fazendo primeiros depósitos',

        PromotedAccount: 'Conta promovida',

        HowInvite: 'Como convidar',
        DailyInvitation: 'Convite diário',
        WheelFortune: 'Roda da sorte',
        WheelFortuneTips: 'Convide seus amigos para se cadastrar e completar a recarga para receber uma recompensa de até ',
        InvitationRules: 'Regras de convite',
        ShareLinksTips: 'Compartilhe links por meio de aplicativos sociais',
        CopyLinkToFriends: 'Copie o link de convite e envie para seus amigos.',
        InviteValidUsers: 'Convide usuários válidos',
        getRewardsTimeTips: 'As recompensas serão distribuídas às 00:00 do dia seguinte.',
        EarnRewards: 'Ganhe recompensas',
        ImportantNotice: 'Aviso importante:',
        ImportantNoticeContent: ' Para garantir a imparcialidade na plataforma, adotamos medidas contra fraudes. Usuários que fraudarem terão suas contas suspensas permanentemente, seus fundos ilícitos congelados e serão responsabilizados perante a lei.',

        rule2: '🎉 Convite com Recompensas 🎉',
        rule3: '🔥 Convide seus amigos e ganhe sem parar!',
        rule4: '👉 📱 Quando seu amigo se cadastrar com seu número de telefone e fizer sua primeira recarga, ele se tornará um usuário válido.',
        rule5: '💎 Por cada usuário válido que convidar → você receberá uma recompensa imediata!',
        rule6: '🚀 Quanto mais convidar, mais ganha — não há limite!',
        rule7: '✨ Compartilhe agora mesmo com seus amigos e não deixe as recompensas escaparem! 🎁🎊',

        Invite: 'Convidar',
        bonus: 'bónus',
        TotalPrize: 'Prêmio total',
        BonusesAlreadySettled: 'Bônus já liquidados',
        BonusPendingSettlement: 'Bônus pendente de liquidação',
        UpdateEveryHours: 'Atualizar a cada 24 horas',
        TotalData: 'Dados totais',
        RewardsFirstRecharge: 'Recompensas pela primeira recarga',
        TotalReward: 'Recompensa total',
        DailyData: 'Dados diários',
        Data: 'Dados',
        RechargeUser: 'Recarregar usuário',
        FirstRechargeRewards: 'Recompensas da primeira recarga',
        AmountCollectedBehalf: 'Valor do depósito',
        CollectionPersonCount: 'Número de depositantes',
        SaveImage: 'Salvar imagem',
        reward: 'bônus'
    },
    deposit: {
        PaymentMethodsRregion: 'Métodos de pagamento para a região',
        DepositMethods: 'Métodos de depósito',
        Deposit: 'Depósito',
        FirstDeposit: 'Bono por dep ósito',
        Details: 'Detalhes',
        Amount: 'Valor',
        Extra: 'Extra',
        noBonus: 'sem bônus',
        PleaseEnterDeposit: 'Por favor, insira o valor do depósito',
        isMinRechargeAmtTips: 'O valor da recarga deve ser maior que o valor mínimo de recarga',
        isMaxRechargeAmtTips: 'O valor da recarga deve ser menor que o valor máximo de recarga',
        showBonusTips: 'Não participar das promoções de depósito',
        rewardPercentageTxt1_1: 'Acima de',
        rewardPercentageTxt1_2: 'mais',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Primeira Recarga Diária ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Primeira Recarga após Cadastro ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Change: 'Alterar',
        DepositBonus: 'Bônus de Depósito',
        DepositAmount: 'Valor do Depósito',
        Bonus: 'Bônus',
        DepositTips: 'Os depósitos na plataforma oferecem recompensas generosas; depositar um valor específico a cada vez garante um bônus.',
        DepositTips2: 'Por favor, use o T-bank ou Sber para recarregar, pois outros bancos não são suportados no momento.',
        howTitle: 'Como Resgatar o Bônus de Depósito?',
        Step: 'Passo',
        Step2Title: 'Resgatar bônus de depósito',
        howTips1: 'Acesse a seção de depósito. Escolha o método de depósito preferido para fazer o depósito.',
        howTips2: 'Após o depósito ser concluído, você receberá o bônus correspondente com base no valor do depósito e na taxa de bônus.',
        TransferDeposit: 'Depósito via USDT',
        OnlineDeposit: 'Depósito Online',
        ExchangeRate: 'Taxa de câmbio',
        Tutorial: 'Tutorial de recarga via USDT',
        TransferAmount: 'Valor da transferência :',
        TargetAccount: 'Conta destino :',
        showTips: 'Após o sistema detectar sua transferência, seu saldo será aumentado',
        transferred: 'Já fiz a transferência',
        information: 'Informações da transferência',
        name: 'Nome do beneficiário :',
        bank: 'Banco :'
    },
    DepositDetails: {
        DepositDetails: 'Detalhes do Depósito',
        WaitingForPayment: 'Aguardando pagamento.',
        countDownTxt1: 'Por favor,',
        countDownTxt2: 'complete o depósito',
        ExchangeRate: 'Taxa de câmbio',
        DepositMethod: 'Método de Depósito',
        Currency: 'Moeda',
        MainnetProtocol: 'Protocolo da Mainnet (canal de rede, muito importante)',
        PaymentAddress: 'Endereço de Pagamento',
        CreationTime: 'Data de Criação',
        OrderNumber: 'Número do Pedido',
        TransactionRemark: 'Comentário da Transação',
        cashAddress: 'Endereço de dinheiro',
        DepositTips1: '1. Certifique-se do valor correto após deduzir a taxa de saque (o valor recebido correto) para concluir a transação; caso contrário, o depósito não será bem-sucedido.',
        DepositTips2: '2. Confirme que o protocolo da mainnet da sua transferência/depósito corresponde ao protocolo da mainnet selecionado. Caso contrário, o depósito/transferência não será bem-sucedido ou será reembolsado.',
        DepositTips3: '3. Apenas suporta USDT. Por favor, não transfira outras moedas para este endereço.',
        cancelBtn: 'cancelar pedido',
        TransferredBtn: 'Já fiz a transferência',
        ContinueBtn: 'Continuar com o Depósito',
        hashAddress: 'Endereço Hash',
        pleasetEnterHashAddress: 'por favor, insira o endereço Hash',
        cancelOrderTips: 'Deseja cancelar este pedido de pagamento?',
        waitPayTips: 'Atualmente, existem pedidos não pagos. Deseja prosseguir com o pagamento?'
    },
    Withdraw: {
        currency: 'moeda',
        Withdraw: 'Sacar',
        BalanceRecords: 'Histórico de Saldo',
        chooseAmountTitle: 'Escolha ou insira o valor',
        needBonus: 'Preciso de bônus',
        DepositAmount: 'Valor do Depósito',
        Bonus: 'Bônus',
        TotalReceive: 'Total a Receber',
        PAY: 'PAGAR',
        PaymentProblem: 'Problema com o Pagamento',
        ClickForHelp: 'Clique para obter ajuda',
        DepositNotes: 'Notas sobre Depósito',
        BalanceWithdraw: 'Saque de Saldo',
        BonusWithdraw: 'Saque de Bônus',
        ChooseFundsType: 'Escolha o Tipo de Recursos',
        BettingLootRelease: 'Liberar recompensas de apostas',
        MinimumWithdrawal: 'Saque Mínimo',
        WithidrawLimitPerday: 'Limite de Saque Diário',
        WithdrawTimePerday: 'Horário de Saque Diário',
        TotalBalance: 'Saldo Total',
        TotalBonus: 'Bônus Total',
        WithdrawableBalance: 'Saldo Disponível para Saque',
        WithdrawableBonus: 'Bônus Restante',
        WithdrawAmount: 'Valor do Saque',
        All: 'Todo',
        ChooseYourBankcard: 'Escolha seu cartão bancário',
        AddABankCardFirst: 'Adicione um cartão bancário primeiro',
        WithdrawPassword: 'Senha de Saque',
        InputWithdrawPassword: 'Insira a senha de saque',
        Fee: 'Taxa',
        commission: 'Comissão',
        Receive: 'Receber',
        WithdrawNotes: 'Observação: 3%+6Rs do valor do saque serão deduzidos como comissão bancária. Por favor, verifique novamente as informações do saque. Se o saque falhar ou houver dúvidas, entre em contato com o atendimento 24/7.',
        WithdrawalDetails: 'Detalhes do Saque',
        PleaseEnterDeposit: 'Por favor, insira o valor do depósito',
        PleaseEnterWithdraw: 'Por favor, insira o valor do saque',
        withdrawalAmountMust10: 'O valor do saque deve ser um múltiplo de 10.',
        PleaseChooseBank: 'Primeiro, insira as informações do cartão bancário',
        PleaseEnterWithdrawPassword: 'Por favor, insira a senha de saque',
        PleaseEnterInteger: 'Por favor, insira um número inteiro para o valor do saque',
        PleaseEnterMiniWithdrawPrice: 'O valor do saque não pode ser menor que o valor mínimo de saque',
        PleaseEnterMaxWithdrawAmt: 'O montante de retirada não pode exceder o montante máximo de retirada',
        notInTime1: 'Horário disponível para saque:',
        notInTime2: 'Horário de liquidação do sistema:',
        notInTime3: 'Após o início do saque, o valor será creditado na conta dentro de 24 horas. Se houver dúvidas, entre em contato com o nosso atendimento.',
        NotDealWith: 'Em andamento',
        withdrawTips: 'Todas as recompensas de indicação e comissões serão pagas como bônus. O bônus pode ser sacado diretamente ou convertido em saldo.',
        ExtraBonus: 'Bônus Extra: ',
        ratetxt1: 'Ainda preciso apostar',
        ratetxt2: 'para sacar',
        ratetxt3: ' ainda precisa apostar ',
        ratetxt4: ' para sacar',
        ratetxt5: 'Incumprimento dos requisitos de retirada.',
        VerifyIdentity: 'Verificar Identidade',
        ChooseDepositType: 'Escolha o Tipo de Depósito',
        TransferDeposit: 'Depósito via Transferência',
        OnlineDeposit: 'Depósito Online',
        EnterAmount: 'Insira o valor',
        isMinRechargeAmtTips: 'O valor da recarga deve ser maior que o valor mínimo de recarga',
        isMaxRechargeAmtTips: 'O valor da recarga deve ser menor que o valor máximo de recarga',
        rewardPercentageTxt1_1: 'Acima de',
        rewardPercentageTxt1_2: 'mais',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Primeira Recarga Diária ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Primeira Recarga após Cadastro ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Illustrate: 'Ilustração',

        Today: 'Hoje',
        Yesterday: 'Ontem',
        Week: 'Semana',
        thisWeek: 'Esta Semana',
        lastWeek: 'Semana Passada',
        Month: 'Mês',
        thisMonth: 'Este Mês',
        lastMonth: 'Mês Passado',
        RequestWithdrawal: 'Solicitar Saque',
        WithdrawalAmount: 'Valor do Saque',
        BettingRecords: 'Histórico de Apostas',
        AuditRecords: 'Histórico de Auditoria',
        WithdrawalRecord: 'Histórico de Saques',
        BetRecordTips1: 'Ainda precisa apostar efetivamente ',
        BetRecordTips2: ' para sacar!',
        GameName: 'Nome do Jogo',
        TotalWithdrawal: 'Total de Saques',
        TypeBalance: 'Tipo de Saldo',
        RemainingBalance: 'Saldo Restante',

        NoBankTips: 'Não foi definida senha de saque nem cartão bancário. Por favor, acesse as configurações.',
        DepositTips: 'Lembrete: Caro Cliente: Olá! Para que o saque seja creditado na sua conta pontualmente, certifique-se de preencher um número de conta e nome verdadeiros e válidos, e verifique cuidadosamente se estão corretos. Obrigado!',
        withdrawTips1: 'Termos de Uso: Caros clientes, para a segurança dos seus recursos e a chegada pontual dos mesmos, verifique novamente se a sua conta receptora está correta.',
        PleaseEnterWithdrawAmt2: 'Por favor, insira o valor do saque',
        ManageAccount: 'Gerenciar Conta',
        Add: 'Adicionar',
        SetDefault: 'Definir como padrão',

        InsertPassword: 'Insira a Senha',
        withdrawPwdPopupTips: 'Para a segurança da sua conta, insira a senha de saque',

        TransferDigital: 'Transferir para moeda digital',
        Focus: 'Foco',
        OnlineWithdraw: 'Saque Online',
        TransferWithdraw: 'Retirada de USDT',
        USDTPaymentAddress: 'Endereço de pagamento de USDT',
        PleaseEnterUSDTPaymentAddress: 'Por favor, insira o endereço de pagamento de USDT',
        WithdrawTips1: 'Desconto no Saque: Saques não estão disponíveis às sextas, sábados e domingos. Se quiser sacar nesses três dias, recomendamos usar USDT. Os recursos em USDT serão creditados na sua conta em até 10 minutos! Se os recursos não forem creditados em 10 minutos, por favor, seja paciente, pois os usuários são analisados um por um. Se houver dúvidas, entre em contato com o atendimento.',
        WithdrawTips2: 'Lembrança de retirada: retirada de um cartão de banco requer pelo menos ',
        WithdrawTips3: ', e retirada de USDT requer pelo menos ',
        WithdrawTips4: '. Quando você depositar fundos em seu cartão bancário, você receberá os fundos dentro de 24 horas! Retirar USDT em 10 minutos!',
        disabledWithdraw: 'A função de retirada da conta corrente foi desativada. Entre em contato com o serviço de atendimento ao cliente!' // 当前账户禁止提现
    },
    bankset: {
        BankCardDetails: 'Detalhes do Cartão Bancário',
        Type: 'Tipo',
        AccountName: 'Nome da Conta',
        NameOfTheAccountHolder: 'Nome do Titular da Conta',
        PIXAccount: 'Conta PIX',
        InputPIXAccount: 'Insira a conta PIX',
        CPFAccount: 'Conta CPF',
        PleaseEnterCPF: 'Por favor, insira o CPF',
        WithdrawPassword: 'Senha de Saque',
        InputWithdrawalPassword: 'Insira a senha de saque',
        ConfirmWithdrawalPassword: 'Confirme a senha de saque',
        PleaseEnterWithdrawPassword: 'Por favor, insira a senha de saque',
        InputConfirmWithdrawalPassword: 'Insira novamente a senha de saque para confirmação',
        ChooseCertificateType: 'Escolha o tipo de documento',
        InputAccountName: 'Insira o nome da conta',
        InputInconsistentWithdrawPassword: 'As senhas de saque inseridas não coincidem',
        PayeeAccount: 'Número da conta do beneficiário',
        BankName: 'Nome do Banco',
        bankCardNumber: 'Número do cartão bancário',
        TaxID: 'ID Fiscal',
        PleaseEnterTaxID: 'Por favor, insira o ID Fiscal',
        TaxIDTips: 'Por favor, insira um número fiscal com 12 ou 13 caracteres',
        ChooseBank: 'Escolha um banco',
        PleaseSelectBank: 'Por favor, selecione um banco',
        AccountPhone: 'Número de telefone',
        EnterPhoneNumber: 'insira o número de telefone',
        PleaseEnterPhoneNumber: 'Por favor, insira seu número de telefone',
        email: 'E-mail',
        PleaseEnterEmail: 'Por favor, insira seu endereço de e-mail',
        EmailFormat: 'Formato de e-mail incorreto',
        InputPayeeAccount: 'Por favor, insira o número da conta receptora',
        PleaseSelectChannelName: 'Por favor, selecione o nome do canal',
        Save: 'Salvar',
        PayeeAccountTips1: 'Por favor, insira um número de telefone com 10 dígitos',
        PayeeAccountTips2: 'Por favor, insira um número de cartão bancário com 16 dígitos',
        PayeeAccountTips3: 'Por favor, insira um número de cartão bancário com 18 dígitos',
        WithdrawTips: 'Por favor, insira o número de telefone vinculado ao T-bank para saque. Outros bancos não são suportados no momento',
        PIXAccountCNPJ: '11 dígitos, formato ***.***.***-**',
        ConfirmPIXAccount: 'Confirmar Conta PIX',
        NamePayee: 'Nome do Beneficiário',
        phoneNumber: 'número de celular',
        VerificationCode: 'Código de Verificação',
        InputPIXAccountAgain: 'Insira novamente a conta PIX',
        InputBankIFSC: 'Insira o IFSC do Banco',
        InputNamePayee: 'Insira o nome do beneficiário',
        InputVerificationCode: 'Insira o código de verificação',
        CPFAccountCNPJ: 'Insira o código da empresa',
        ConfirmCPFAccount: 'Confirmar Conta CPF',
        Tips: 'Precisa alterar? Entre em contato com o atendimento',

        AccountType: 'Tipo de Conta',
        PleaseSelectAccountType: 'Por favor, selecione o tipo de conta',
        ChannelName: 'Nome do Canal',
        IDCard: 'Cartão de Identidade',
        PleaseEnterIDCardNo: 'Por favor, insira o número do cartão de identidade',
        IDCardNo13Int: 'O número do cartão de identidade deve ser composto por 13 dígitos puros',
        Payee10Int: 'A conta do beneficiário deve ser um número de 10 dígitos puros iniciado por 3',

        linkBankTips: 'Conta não vinculada a cartão bancário. Por favor, acesse para vincular',
        PhoneFormatPeru: 'O número de telefone deve ser composto por 9 dígitos puros',

        InterbankAccountCode: 'Código de Conta Interbancário',
        PleaseEnterInterbankAccountCode: 'Por favor, insira o código de conta interbancário',

        IdentityType: 'Tipo de Identidade',
        PleaseSelectIdentityType: 'Por favor, selecione o tipo de identidade',

        IDNumber: 'Número de Identificação',
        PleaseEnterIDNumber: 'Por favor, insira seu número de identificação',
        WithdrawalAccount: 'Conta para Saque',

        banksetPopupTips1: 'Apenas é possível adicionar contas PIX do tipo pix-CPF;',
        banksetPopupTips2: 'Verifique cuidadosamente, caso contrário, o valor não será creditado.',
        banksetPopupTips3: 'Confirme o nome e o cartão para garantir o crédito dos recursos.',
        PhoneFormatBrazil: 'Número de celular: 8-14 dígitos',
        WrongWithdrawalPassword: 'Senha de saque incorreta',
        PleaseEnterIDCardName: 'Preencha o nome verdadeiro para facilitar saques futuros!',
        DebitCard: 'Cartão de Débito'
    },
    withdrawPwd: {
        title: 'Senha de Saque',
        withdrawPwdTips1: 'Para garantir a segurança dos seus recursos, primeiro é necessário definir uma senha de saque!',
        withdrawPwdTips2: 'Defina sua senha de saque',
        withdrawPwdLabel1: 'Nova senha de saque',
        withdrawPwdLabel2: 'Confirme sua senha de saque',
        withdrawPwdTips3: 'Atenção: A senha de saque é muito importante para proteger seus recursos. Mantenha-a em segredo para evitar perdas financeiras.',
        notContinuousNumbers: 'Não pode ser 6 números iguais ou consecutivos',
        PleaseEnterWithdrawalPassword: 'Por favor, insira a senha de saque',
        ConfirmWithdrawalPassword: 'Confirme a senha de saque',
        InputInconsistentWithdrawPassword: 'As senhas de saque inseridas não coincidem'
    },
    Notification: {
        Notification: 'Notificação',
        news: 'Notícias',
        nomore: 'Não há mais'
    },
    bonusCenter: {
        BonusDetails: 'Detalhes do Bônus',
        BonusCategories: 'Categorias de Bônus',
        WeeklyBonus: 'Bônus Semanal',
        MonthlyBonus: 'Bônus Mensal',
        LevelupBonus: 'Bônus de Aumento de Nível',
        BonusRain: 'Envelope Vermelho',
        DepositBonus: 'Bônus de Depósito',
        SpecialBonus: 'Bônus Especial',
        BonusTransactions: 'Transações de Bônus',
        BonusType: 'Tipo de Bônus',
        ClaimedAmount: 'Valor Resgatado',
        Time: 'Hora',
        OopsNodatayet: 'Ops! Ainda não há dados!',
        TotalBonusClaime: 'Total de Bônus Resgatados',
        TotalGeneralBonus: 'Bônus de Atividade',
        TotalVIPBonus: 'Bônus VIP Total',
        rechargeBonus: 'Bônus de Recarga',
        Details: 'Detalhes',
        TotalBonus: 'Bônus Total:',
        Rules: 'Regras',
        Bonusends: 'Bônus expira:',
        DepositNow: 'Depositar Agora',
        Generalbonus: 'Bônus Geral',
        Todayevents: 'Atividades de Hoje',
        Nextrain: 'Próxima vez',
        CheckIn: 'Registrar',
        Counts: 'Contagens',
        Deposit: 'Depósito',
        VIPBonus: 'Bônus VIP',
        Levelupbonus: 'Bônus de Aumento de Nível',
        XPtoVIP: 'XP para VIP',
        UpgradeBonus: 'Bônus de Upgrade',
        NextLevelBonus: 'Bônus do Próximo Nível',
        ViewVIPClub: 'Ver Clube VIP',
        Wager: 'Aposta',
        VIP: 'VIP',
        Unlockendless: 'Desbloqueie benefícios infinitos',
        Generousbonuses: 'Bônus generosos estão prontos! Junte-se a nós e encontre seus tesouros.',
        JoinNow: 'Junte-se Agora',
        Upgradebonuses: 'Suba de nível VIP para ganhar bônus',
        Invitefriendss: 'Convide amigos para jogar e ganhar bônus',
        Completequest: 'Complete missões para ganhar bônus',
        Winbigwith: 'Ganhe muito com nossos bônus semanais e mensais!',
        Discover: 'Descubra bônus extraordinários',
        numerousbonuses: 'Oferecemos diversos bônus para cada usuário. Há recompensas novas todos os dias e todas as semanas.',
        Signbonus: 'Cadastre-se e ganhe bônus',
        LevelupVIP: 'Suba de nível VIP, mais recompensas!',
        VIPstatusmeans: 'O status VIP significa mais valor aqui. Você pode construir riqueza rapidamente e criar uma base financeira sólida ao desbloquear seus privilégios.',
        Whatget: 'O que os VIPs ganham?',
        Saygoodbye: 'Adeus aos jogos comuns, olá ao luxo puro.',
        RedeemBonusCode: 'Resgatar Código de Bônus',
        RedeemCode: 'Código de Resgate',
        AllBonuses: 'Todos os Bônus',
        eventManage: 'Bônus de Atividade',
        VIPCycleReward: 'Recompensa de Nível VIP',
        Extend: 'Bônus de Promoção',
        reliefMoneyEvent: 'Atividade de Dinheiro de Resgate',
        singInEvent: 'Atividade de Registro Diário',
        luckyWheelEvent: 'Atividade de Roda da Sorte',
        redPacletEvent: 'Atividade de Envelope Vermelho',
        gameBettingEvent: 'Atividade de Apostas em Jogos',
        pinduoduoEvent: 'Atividades de Indicação',
        rankingListEvent: 'Atividade de Ranking',
        registerRewardsEvent: 'Atividade de Cadastro',
        VIPWeeklyReward: 'Recompensas Semanais VIP',
        VIPMonthlyReward: 'Recompensas Mensais VIP',
        VIPLevelUpReward: 'Recompensa de Aumento de Nível VIP',
        Redeemyour: 'Resgate seu código de bônus abaixo.',
        Redeem: 'Resgatar',
        Unlocked: 'Desbloqueado',
        RechargeAmount: 'Valor de Recarga',
        RegisterAndObtain: 'Register e obter',
        bonus: 'bónus',
        FreeSpins: ' girações livres',
        depositBonusTips: ' - Casino de pagamento instantâneo online onde sua stripper preferida joga',
        GetBonus: 'Obter um bónus',
        depositBonusTips2: 'Register e receber bónus',
        depositBonusTips3: 'A cada recarga de saldo, você recebe bônus no valor total de ',
        depositBonusTips4: '%, se considerar todos os ',
        depositBonusTips5: ' depósitos.',
        depositBonusTips6: '(jogo de giro gratuito: Big Bass Christmas Bash)',
        thDeposit: 'º Depósito'
    },
    lossSupport: {
        title: 'Apoio para Perdas',
        lossSupport: 'Apoio',
        yesterdayLoss: 'Perdas de ontem',
        todayBonus: 'Bônus de Apoio de Hoje',
        loseMoney: 'Valor da Perda',
        extraprizes: 'Prêmios Extras',
        amountDamage: 'Valor do Dano',
        AmountReward: 'Valor da Recompensa',
        EventIntro: 'Instruções da Atividade：',
        VIPLevel: 'Nível VIP'
    },
    rebate: {
        title: 'Reembolsos em Apostas',
        BettingVolume: 'Volume de Apostas',
        RewardAmount: 'Valor da Recompensa',
        EventIntro: 'Instruções da Atividade：'
    },
    downApp: {
        downAppSuccTips: 'Você instalou o aplicativo com sucesso.',
        downAppSuccTips2: 'Você já tem o aplicativo instalado. Ou clique no ícone do botão de download no canto superior direito do endereço URL do navegador para reinstalar.',
        SaveVersionDesktop: 'Salvar versão web no desktop',
        SaveVersionTips: 'Clique para baixar o aplicativo rapidamente no seu desktop',
        QuickVersion: 'Versão Rápida',
        NormalVersion: 'Versão Normal',
        download: 'Baixar',
        NotInDevice: 'Não compatível com este dispositivo',
        Games: 'Jogos',
        Apps: 'Aplicativos',
        Movies: 'Filmes',
        Books: 'Livros',
        Kids: 'Infantil',
        ProductMadness: 'Frenesi de Produtos',
        InAppPurchases: 'Compras dentro do Aplicativo',
        reviews: 'avaliações',
        Downloads: 'Downloads',
        Install: 'Instalar',
        Share: 'Compartilhar',
        AddToWishlist: 'Adicionar à Lista de Desejos',
        appAvailableDevice: 'Este aplicativo está disponível para o seu dispositivo',
        AboutGame: 'Sobre este jogo',
        comment1: 'Experimente a emoção de jogos de cartas e a adrenalina de apostas de alto valor no gd-goatbet! Junte-se a uma comunidade vibrante de entusiastas de cartas neste jogo imersivo e social. Jogue Teen Patti em vários modos, participe de torneios emocionantes e torne-se o melhor no gd-goatbet. Com sua jogabilidade autêntica, recursos sociais e espírito competitivo, o gd-goatbet oferece uma experiência de jogo de cartas cativante que fará você voltar sempre mais.',
        comment2: '1. Experiência Autêntica de Teen Patti: Mergulhe na experiência autêntica e tradicional do jogo de cartas Teen Patti, com regras realistas e jogabilidade envolvente.',
        comment3: '2. Modos de Jogo Diversos: Explore uma variedade de modos de jogo, desde o Teen Patti clássico até variações inovadoras, oferecendo uma experiência de jogo dinâmica e divertida.',
        comment4: '3. Jogo de Cartas Social: Conecte-se com amigos, junte-se a clubes e participe de partidas multiplayer, promovendo um ambiente de jogo social e interativo.',
        DataSafety: 'Segurança de Dados',
        comment5: 'A segurança começa com a compreensão de como os desenvolvedores coletam e compartilham seus dados. As práticas de privacidade e segurança de dados podem variar conforme o uso, região e idade. O desenvolvedor forneceu estas informações e pode atualizá-las ao longo do tempo.',
        comment6: 'Este aplicativo pode compartilhar estes tipos de dados com terceiros',
        comment7: 'Localização, informações pessoais e outros 6 tipos',
        comment8: 'Este aplicativo pode coletar estes tipos de dados',
        comment9: 'Localização, informações pessoais e 6 outros',
        comment10: 'Dados criptografados durante a transmissão',
        comment11: 'Você pode solicitar a exclusão dos dados',
        SeeDetails: 'Ver detalhes',
        RatingsAndReviews: 'Avaliações e Comentários',
        Phone: 'Telefone',
        Tablet: 'Tablet',
        October: 'Outubro',
        comment12: 'Ótima seleção de jogos populares que também estão nos cassinos ao vivo, e muito divertidos de jogar! Apenas assistir anúncios pode manter o jogo, mas às vezes pode ser muito lento. Esteja preparado para fazer compras ou ter muita paciência. Às vezes, é necessário assistir a um anúncio de 30 segundos a 1 minuto entre algumas mãos de jogo, e isso pode acontecer por várias mãos. Em alguns jogos, não é possível cumprir os requisitos de bônus a menos que compre dinheiro para jogar. AINDA ASSIM, é o meu aplicativo de cassino favorito para jogar!',
        comment13: '3.394 pessoas acharam este comentário útil',
        comment14: 'Você achou isso útil?',
        Yes: 'Sim',
        No: 'Não',
        September: 'Setembro',
        comment15: 'Realmente gosto deste jogo. Tem uma variedade de caça-níqueis diferentes para jogar. Posso ganhar moedas extras enquanto jogo. Não muitos anúncios para assistir. O valor das moedas ao comprar é menor do que em outros jogos, mas devido à qualidade deste jogo, valem a pena na minha opinião. Baixei e depois deletei outros aplicativos após jogá-los.',
        comment16: '1.110 pessoas acharam este comentário útil',
        comment17: 'Você achou isso útil?',
        WhatNew: 'Novidades',
        comment18: 'Obtenha nossos NOVOS jogos na nossa última atualização!',
        comment19: 'Para a melhor experiência e mais DIVERSÃO, corrigimos bugs e otimizamos o seu jogo.',
        AppSupport: 'Suporte ao Aplicativo',
        SimilarGames: 'Jogos Similares',
        LightningLinkCasinoSlots: 'Lightning Link Casino Slots',
        QuickHitCasinoSlotGames: 'Quick Hit Casino Slot Games',
        SciPlay: 'SciPlay',
        LuckyTimeSlots: 'Lucky Time Slots',
        DGNGames: 'DGN Games',
        CashTornadoSlotsCasino: 'Cash Tornado™ Slots - Casino',
        ZerooGravityGames: 'Zeroo Gravity Games',
        GoldFishCasinoSlot: 'Gold Fish Casino Slot',
        FlagInappropriate: 'Marcar como inadequado',
        GooglePlay: 'Play',
        PlayPass: 'Play Pass',
        PlayPoints: 'Pontos Play',
        GiftCards: 'Cartões de Presente',
        Redeem: 'Resgatar',
        RefundPolicy: 'Política de Reembolso',
        KidsFamily: 'Infantil e Família',
        ParentGuide: 'Guia para Pais',
        FamilySharing: 'Compartilhamento Familiar',
        TermsService: 'Termos de Serviço',
        Privacidade: 'Privacidade',
        SobreGooglePlay: 'Sobre o Play',
        Desenvolvedores: 'Desenvolvedores',
        GoogleStore: 'Loja',
        UnitedStates: 'Estados Unidos (Inglês)',

        AppStore: 'App Store',
        DesignedIPhone: 'Projetado para iPhone',
        get: 'obter',
        iPhoneScreenshots: 'Capturas de Tela do iPhone',
        AppPrivacy: 'Privacidade do Aplicativo',
        intro1: 'O desenvolvedor, ',
        intro2: ', indicou que as práticas de privacidade do aplicativo podem incluir o tratamento de dados conforme descrito abaixo. Para mais informações, consulte a ',
        intro3: 'política de privacidade do desenvolvedor',
        intro4: 'Dados Não Coletados',
        intro5: 'O desenvolvedor não coleta nenhum dado deste aplicativo.',
        intro6: 'As práticas de privacidade podem variar, por exemplo, conforme os recursos que você usa ou sua idade. ',
        intro7: 'Informações',
        Seller: 'Vendedor',
        Size: 'Tamanho',
        Category: 'Categoria',
        Compatibility: 'Compatibilidade',
        iPhone: 'iPhone',
        support1: 'Requer iOS 10.0 ou posterior.',
        iPodTouch: 'iPod touch',
        support2: 'Requer iOS 10.0 ou posterior.',
        Mac: 'Mac',
        support3: 'Requer macOS 11.0 ou posterior e um Mac com chip Apple M1 ou posterior.',
        Languages: 'Idiomas',
        EnglishSimplifiedChinese: 'Inglês, Chinês Simplificado',
        AgeRating: 'Classificação Etária',
        UnrestrictedWebAccess: 'Acesso Ilimitado à Web',
        InfrequentMildHorrorFearThemes: 'Temas de Terror/Medo Leves e Poucos Frequentes',
        Copyright: 'Copyright',
        Price: 'Preço',
        Free: 'Gratuito',
        PrivacyPolicy: 'Política de Privacidade',
        Supports: 'Suporta',
        GameCenter: 'Game Center',
        GameCenterTips: 'Desafie amigos e verifique rankings e conquistas.',
        Morewaysshop: 'Mais maneiras de comprar',
        FindAppleStore: 'Encontre uma Apple Store',
        or: 'ou',
        otherRetailer: 'outro revendedor',
        nearYou: 'perto de você. ',
        OrCall: 'Ou ligue para 1-800-MY-APPLE.',
        ChooseYourCountryRegion: 'Escolha seu país ou região',
        TermsUse: 'Termos de Uso',
        SalesRefunds: 'Vendas e Reembolsos',
        Legal: 'Legal',
        SiteMap: 'Mapa do Site',
        ClickButtonToDownload: 'Baixe o aplicativo para saques mais seguros',
        ClickButtonToDownload2: 'Baixe o aplicativo para jogar',
        ApplicableWindows: 'aplicação',
        ApplicableWindowsTips: 'Adicionar acesso rápido à área de Trabalho'
    },
    event: {
        Detail: 'Detalhe',
        greatBonus: 'Excelente Bônus Para ',
        everyDeposit: 'Cada Depósito',
        firstDeposit: 'Primeiro Depósito',
        secondDeposit: 'Segundo Depósito',
        thirdDeposit: 'Terceiro Depósito',
        upTo: 'Até',
        allPlayers: 'Disponível para todos os jogadores ',
        before: 'Antes de',
        Bonus: 'Bônus',
        Deposit: 'Depósito',
        Recompensas: 'Special rewards',
        preparado: 'Weve prepared many bonuses for you, so dont miss out! Come and claim them!',
        RewardReceived: 'Recompensa recebida',
        redPacketBtnsName: 'Aberto no horário designado'
    },
    person: {
        Bets: 'Apostas',
        Balance: 'Saldo',
        Bonus: 'Bônus',
        Transaction: 'Transação',
        History: 'Histórico',
        Welcome: 'Bem-vindo(a) ao ',
        signIn: 'Primeiro, faça cadastro ou login',
        invite: 'Convidar amigos',
        redPacket: 'Envelope Vermelho',
        Notification: 'Notificação',
        Promotion: 'Promoção',
        VIPClub: 'Clube VIP',
        LiveChat: 'Chat ao Vivo',
        AccountSettings: 'Configurações da Conta',
        Install: 'Instalar',
        BonusTransfer: 'Transferência de Bônus',
        transferMsg: 'Bônus insuficiente.',
        transferTips1: 'Deseja transferir ',
        transferTips2: ' bônus para saldo?',
        transferTips3: 'Transferir agora',
        InvitationCenter: 'Centro de Indicações',
        PersonalCenter: 'Centro Pessoal',
        VIPNeed: 'Requisitos para subir para o VIP',
        AccountTotal: 'Total Da Conta'
    },
    Vip: {
        VIPSupport: 'Atendimento VIP',
        LevelBenefits: 'Nível VIP e Benefícios',
        Deposits: 'Depósitos',
        Bets: 'Apostas',
        or: 'ou',
        to: 'para',
        joinClub: 'Junte-se ao Clube VIP. Desbloqueie reembolsos altos. Diversos presentes delicados. Isso vai surpreendê-lo(a)!',
        levelUp: 'Subir de Nível para VIP',
        Steps: 'Passos',
        Benefits: 'Benefícios',
        benefits1: 'Bônus de aumento de nível',
        benefits2: 'Bônus semanal',
        benefits3: 'Bônus mensal',
        info1: 'Suba de nível VIP para ganhar bônus!',
        info2: 'Resgate bônus gratuitos todas as semanas.',
        info3: 'Resgate bônus gratuitos todos os meses.',
        More: 'Mais',
        promotionTip: 'Consulte nossas promoções para mais detalhes.',
        Promotions: 'Promoções',
        FAQ: 'Dúvidas Frequentes',
        question1: '1. O que é "Bônus de Aumento de Nível"?',
        answer1: 'Um "bônus de aumento de nível" é um privilégio VIP onde as recompensas aumentam à medida que você avança para níveis VIP mais altos.',
        question2: '2. Benefícios do upgrade para VIP',
        answer2: 'Subir de nível VIP permite obter valor de saque maior e taxa de saque menor!',
        LevelUpBonus: 'Bônus de Aumento de Nível',
        WeeklyBonus: 'Bônus Semanal',
        MonthlyBonus: 'Bônus Mensal',
        Level: 'Nível',
        RequiredDeposit: 'Depósito Necessário',
        RequiredBet: 'Aposta Necessária',
        Get: 'Ganhar',
        UpgradeBonus: 'Bônus de Upgrade',
        vipRewards: 'Cadastre-se e Ganhe Recompensas VIP Exclusivas!',
        earnPoints: 'Aposte e ganhe pontos!',
        levelUpBenifits: 'Desbloqueie Recompensas, Aumente seus Benefícios!',
        Step1: 'Passo 1',
        Step2: 'Passo 2',
        Step3: 'Passo 3',
        LevelReward: 'Recompensa de nível',
        UpgradeYourVIPLevelReceiveRewards: 'Melhore seu nível VIP para receber recompensas.',
        TotalCheckInRewards: 'Total de recompensas de check-in',
        WeeklySalary: 'Salário semanal',
        DistributedAutomaticallyEveryWednesday: 'Distribuído automaticamente todas as quartas-feiras.',
        LossSubsidy: 'Subsídio por perdas',
        DistributedAutomaticallyEveryMonday: 'Distribuído automaticamente todas as segundas-feiras.',
        Withdraw: 'Sacar',
        MaximumSingleWithdrawalLimit: 'Limite máximo de saque único',
        NumberWithdrawalsPerDay: 'Número de saques por dia',
        CheckIn: 'Check-in',
        KeepYourVipLevel: 'Mantenha seu n\u00edvel VIP!',
        KeepVipLevelDescription: 'Jogue mensalmente para manter seu n\u00edvel VIP atual. Longos per\u00edodos de inatividade ativar\u00e3o automaticamente um rebaixamento. Continue jogando e aproveite privil\u00e9gios premium sem perder seu n\u00edvel VIP!',
        KeepVipLevelDuring: 'Mantenha o n\u00edvel VIP durante',
        RechargeAmount: 'Valor de recarga',
        BetAmount: 'Valor da aposta'
    },
    MyProfile: {
        Profile: 'Perfil',
        ID: 'ID',
        Join: 'Data de Adesão',
        TotalBet: 'Total de Apostas',
        TotalBonus: 'Bônus Total',
        FavoriteGames: 'Jogos Favoritos'
    },
    Transaction: {
        Transaction: 'Transação',
        TotalAmount: 'Valor Total',
        DepositValue: 'Valor do Depósito',
        Bonus: 'Bônus',
        Received: 'Recebido',
        WithdrawBonus: 'Saque de Bônus',
        Rate: 'Taxa',
        Today: 'Hoje',
        Yesterday: 'Ontem',
        LastThreeDays: 'Últimos 3 Dias',
        LastSevenDays: 'Últimos 7 Dias',
        LastFifteenDays: 'Últimos 15 Dias',
        LastThiryDays: 'Últimos 30 Dias',
        AllState: 'Todos os Status',
        Processing: 'Processando',
        Successful: 'Bem-sucedido',
        Failed: 'Falhou',
        WithdrawFail: 'Saque Falhou',
        Withdrawing: 'Sacando',
        WithdrawSuccess: 'Saque Bem-sucedido',
        PaySuccess: 'Pagamento Bem-sucedido',
        Paying: 'Pagando',
        Fail: 'Falha',
        WaitPay: 'Aguardando Pagamento',
        Cancel: 'Cancelado'
    },
    BetsHistory: {
        BetsHistory: 'Histórico de Apostas'
    },
    Setting: {
        Setting: 'Configurações',
        LiveChat: 'Chat ao Vivo ',
        AccountID: 'ID da Conta',
        PhoneNumber: 'Número de Telefone',
        Password: 'Senha',
        Change: 'Alterar',
        oldPasswordTips: 'insira a senha original',
        PleaseEnterYourOriginalPassword: 'Por favor, insira sua senha original',
        passwordTips: 'Senha (6-16 caracteres)',
        PleaseEnterYourNewPassword: 'Por favor, insira sua nova senha',
        passwordTips2: 'Insira a senha novamente',
        PleaseEnterYourNewPasswordSure: 'Por favor, insira sua nova senha novamente',
        changePwd: 'Alterar senha'
    },
    RedPacket: {
        RedPacket: 'Envelope Vermelho',
        NextEvent: 'Próximo Evento',
        Participate: 'Participar'
    },
    turntable: {
        Roulette: 'Roda de rouleta',
        lottery: 'Loteria',
        title: 'Roda da Fortuna',
        totalTips1: 'Pontos de sorte atuais',
        totalTips2: 'Você ainda precisa apostar',
        totalTips3: 'para obter',
        totalTips4: 'Pontos de Sorte',
        totalTips5: 'A primeira recarga diária pode ganhar ',
        totalTips6: ' pontos de sorte',
        totalTips7: 'Uma única recarga de ',
        totalTips8: ' ou mais pode ganhar um desenho de loteria, sem limite no número de vezes',
        totalTips9: 'O valor ganho pode ser sacado quando ultrapassar os ',
        totalTips10: 'Acabaram os seus giros grátis? Convide seus amigos a se cadastrar e ganhe giros adicionais.',
        totalTips11: 'Você pode ganhar até ',
        totalTips12: ' em prêmios!',
        totalTips13: 'Bem-vindo à roda da sorte.',
        totalTips14: 'Resgate seu generoso bônus!',
        totalTips15: 'Você já completou ',
        totalTips16: ', só faltam ',
        totalTips17: ' em prêmios para você poder sacar seu dinheiro.',
        totalTips18: 'Convidar amigos para completar tarefas.',
        Silver: 'Prata',
        Gold: 'Ouro',
        Diamond: 'Diamante',
        tab1: 'Relatório',
        tab2: 'Minha Referência',
        JustRemoved: 'acabou de ser resgatado',
        drawTitle1: 'Parabéns',
        drawTitle2: 'Infelizmente',
        drawContent1: 'obteve',
        drawContent2: 'Nenhuma recompensa recebida',
        cashOut: 'Sacar',
        InviteFriends: 'Convide amigos para ganhar dinheiro',
        nextFreeSpin: 'Próxima Rodada Grátis:',
        targetAmount: 'Valor Alvo:',
        withdrawSuccessfully: 'Saque bem-sucedido',
        downTimeTips1: 'Após',
        downTimeTips2: 'segundos,',
        downTimeTips3: 'o bônus acumulado e as tentativas de loteria serão zeradas',
        drawNumbers: 'Número de sorteios',
        winPopupTitle: 'Parabéns! Você ganhou:',
        winPopupWithdrawTip: 'Você pode iniciar um saque quando o valor acumulado atingir',
        winPopupButton: 'Ver tarefas',
        winPopupHint: 'Complete missões para ganhar giros grátis',
        sharePopupTitle: 'Convide amigos para ajudar no saque',
        sharePopupRewardLabel: 'Valor da recompensa recebida',
        sharePopupNeedText1: 'Você ainda precisa de',
        sharePopupNeedText2: 'para realizar o saque',
        sharePopupTaskTip: 'Completar as tarefas a seguir pode ajudar você a sacar mais rápido:',
        sharePopupInviteTip1: 'Convide 1 usuário válido do jogo e ganhe',
        sharePopupInviteTip2: 'giro grátis'
    },
    winRankList: {
        RankingList: 'Lista de Classificação',
        Ranking: 'Classificação',
        Rules: 'Regras',
        MyRewards: 'Minhas Recompensas',
        ActivityAward: 'Prêmio da Atividade:',
        Rank: 'Classificação',
        Daily: 'Diário',
        Weekly: 'Semanal',
        Monthly: 'Mensal',
        WeeklyList: 'Lista Semanal',
        MonthlyList: 'Lista Mensal',
        TotalBets: 'Total de Apostas',
        Reward: 'Recompensa:',
        NoRank: 'Sem Classificação',
        MyBets: 'Minhas Apostas',
        RanksLeft: 'Classificações Restantes',
        MyReward: 'Minha Recompensa',
        History: 'Histórico',
        LastDay: 'Último Dia',
        LastWeek: 'Última Semana',
        LastMonth: 'Último Mês',
        Rewards: 'Recompensas',
        PhoneNo: 'Número de Telefone'
    },
    footer: {
        Promo: 'Promoção',
        VIPClub: 'Clube VIP',
        Promotions: 'Promoções',
        ReferAndEarn: 'Indique e Ganhe',
        Bonus: 'Bônus',
        AboutUs: 'Sobre Nós',
        About: 'Sobre',
        DataProtectionPolicy: 'Política de Proteção de Dados',
        BusinessContinuityPolicy: 'Política de Continuidade de Negócios',
        Help: 'Ajuda',
        PrivacyPolicy: 'Política de Privacidade',
        ServiceTerms: 'Termos de Serviço',
        GamblingAddictionWarnings: 'Alertas sobre Dependência de Apostas',
        GamblingTreatmentCenters: 'Centros de Tratamento para Dependência de Apostas',
        ResponsibleGambling: 'Apostas Responsáveis',
        ContactUs: 'Entre em Contato',
        JoinOurGroup: 'Junte-se ao Nosso Grupo',
        ContactViaTelegram: 'Contato via Telegram',
        OnlineServer: 'Servidor Online',
        JoinourCommunity: 'Junte-se à Nossa Comunidade',
        tips1: '1. Este produto é para uso de usuários com mais de 18 anos e é destinado apenas para fins de entretenimento.',
        tips2: '2. Este jogo contém compras dentro do aplicativo.',
        tips3: '3. O fato de um jogador jogar ou ganhar em um jogo de azar social não significa que ele ganhará em apostas de dinheiro real e jogos relacionados no futuro.',
        socialMedia: 'Redes sociais',
        ApplicableTo: 'Aplicado a'
    },
    joinChannel: {
        navTitle: 'Atividades emocionantes',
        mobileTitle: 'Junte-se a comunidade',
        mobileSubtitle: 'Muitas recompensas distribuidas a tempo',
        desktopTitle: 'Entrar nos canais oficiais oferece muitas vantagens.',
        desktopSubtitle: '{domainName} convida voce cordialmente a entrar em nossos canais do Instagram, WhatsApp e Telegram para uma comunicacao mais fluida.',
        instagramBtn: 'Junte-se ao Instagram',
        telegramBtn: 'Junte-se ao Telegram',
        whatsappBtn: 'Junte-se ao WhatsApp',
        infoIntro: 'Anunciaremos as seguintes atividades e informacoes relacionadas em nossos canais do Telegram e WhatsApp:',
        info1: 'Anunciaremos as novas atividades da plataforma em nossos canais do Instagram, Telegram e WhatsApp o mais rapido possivel.',
        info2: 'Atualizaremos periodicamente as recompensas da plataforma em nossos canais do Instagram, Telegram e WhatsApp.',
        info3: 'Compartilharemos diariamente as recompensas oficiais de bonus de {domainName}.',
        info4: 'Anunciaremos a lista de vencedores da plataforma em nossos canais do Instagram, Telegram e WhatsApp o mais rapido possivel.',
        info5: 'Anunciaremos as alteracoes e a manutencao da plataforma em nossos canais do Instagram, Telegram e WhatsApp o mais rapido possivel.',
        info6: 'Anunciaremos as atualizacoes do sistema de recompensas por indicacao em nossos canais do Instagram, Telegram e WhatsApp o mais rapido possivel.',
        info7: 'Qualquer problema relacionado a depositos e saques sera anunciado em nossos canais do Instagram, Telegram e WhatsApp o mais rapido possivel.',
        info8: 'Qualquer manutencao de jogos na plataforma sera anunciada em nossos canais do Instagram, Telegram e WhatsApp o mais rapido possivel.'
    },
    treasureChest: {
        treasureChest: 'peito de tesouro',
        title: 'Recomende amigos para abrir o Baú do Tesouro',
        save: 'Clique para Salvar',
        ReferralLink: 'Link de Indicação',
        directSubordinates: 'Subordinados Diretos',
        ReferralCode: 'Código de Indicação',
        chestInfoTips1: 'O que é um subordinado eficaz? (atende a todos os requisitos)',
        chestInfoTips2: 'Subordinados completaram um total de',
        chestInfoTips3: 'primeiras recargas',
        chestInfoTips4: 'Subordinados acumularam apostas de',
        chestInfoTips5: 'ou mais',
        People: 'Pessoas',
        People2: 'Pessoas',
        People3: 'Pessoas',
        commissionAccount: 'Conta de Comissão',
        todayCommittee: 'Comissão liberada hoje',
        historyCommittee: 'Comissões Históricas Liberadas',
        obtain: 'obter',
        inviteTitle: 'Obtido ao convidar subordinados válidos',
        highestRebate: 'Maior Reembolso',
        commissionBalance: 'Saldo de Comissão',
        totalCommissionIncome: 'Renda Total de Comissão',
        EstimatedCommissionToday: 'Comissão Estimada Hoje',
        YesterdayCommittee: 'Comissão de Ontem',
        register: 'Cadastrar',
        firstChargeMark: 'Marca de Primeira Recarga',
        firstFee: 'Primeira Recarga',
        chargeAmount: 'Valor de Recarga',
        totalHistoricalData: 'Dados Históricos Totais',
        firstLevelSubordinateData: 'Dados de Subordinados de Primeiro Nível',
        secondarySubordinateData: 'Dados de Subordinados de Segundo Nível',
        thirdLevelSubordinateData: 'Dados de Subordinados de Terceiro Nível',
        rewardRatio: 'Taxa de Recompensa',
        collectRebates: 'Recompensas de Recarga',
        teamCollection: 'Recarga da Equipe',
        firstLevelCommission: 'Comissão de Primeiro Nível:',
        secondLevelCommission: 'Comissão de Segundo Nível:',
        thirdLevelCommission: 'Comissão de Terceiro Nível:',
        firstLevelBetting: 'Apostas de Primeiro Nível:',
        secondLevelBetting: 'Apostas de Segundo Nível:',
        thirdLevelBetting: 'Apostas de Terceiro Nível:',
        claim: 'Receber',
        numberTreasureChestsClaimed: 'O número de peitos de tesouro que podem ser reclamados',
        noClaimedTips: 'Atualmente não há caixotes de tesouro disponíveis para coleta'
    },
    Pending: {
        Pending: 'Pendente',
        Hour: 'Hora',
        Type: 'Tipo',
        Bonus: 'Bônus',
        Limit: 'Limite',
        EndTime: 'Data/Hora de Término',
        All: 'Todos',
        DailyAttendance: 'Registro Diário',
        TimedRedEnvelope: 'Envelope Vermelho Temporizado',
        LuckyTurntable: 'Roda da Sorte',
        ReliefMoney: 'Dinheiro de Resgate',
        RegisterRewards: 'Recompensas de Cadastro',
        Other: 'Outro'
    },
    depositTotal: {
        title: 'Recompensas de Recarga Acumulada',
        AccumulatedRecharge: 'Recarga Acumulada',
        GetRewards: 'Obter Recompensas',
        EventIntro: 'Instruções do Evento:'
    },
    depositRepeat: {
        full: 'ao completar',
        RegisterFirstCharge: 'Primeira Recarga após Cadastro',
        DailyFirstCharge: 'Primeira Recarga Diária',
        EachRecharge: 'Cada Recarga',
        give: 'ganhe',
        thRecharge: 'ª Recarga',
        EveryRecharge: 'Toda Recarga',
        EventIntro: 'Instruções do Evento:'
    },
    scratchCards: {
        title: 'Todas as Raspadinhas',
        prizeUpTo1: 'Prêmios até',
        prizeUpTo2: 'Prêmio até',
        pixPayment: 'SEM PIX',
        playNow: 'JOGAR AGORA',
        price: 'Preço',
        maxPrize: 'Prêmio Máximo',
        prizeTable: 'Tabela de Prêmios',
        playFor: 'Jogar por',
        scratchTitle2: 'RASPOU ACHOU GANHOU',
        winCondition1: 'ACHE 3 IGUAIS',
        winCondition2: 'GANHE NA HORA',
        scratchAll: 'Raspar Tudo de Uma Vez',
        shaved: 'Raspado',
        youWon: 'Você Ganhou',
        notThisTime: 'Não Foi Dessa Vez',
        encouragement: 'MAS NÃO DESANIME, A SORTE PODE ESTAR NA PRÓXIMA RASPADINHA',
        playAgain: 'JOGAR NOVAMENTE',
        yourBalance: 'SEU SALDO',
        insufficientBalance: 'Saldo Insuficiente',
        scrape: 'RASPE',
        here: 'AQUI',
        playCard: 'Jogar Raspadinha',
        startPlay: 'Começar a Jogar',
        buyToPlay: 'Comprar para Jogar',
        buyTip1: 'Compre uma raspadinha para começar a jogar',
        buyTip2: 'Clique no botão abaixo para comprar',
        buyCard: 'Comprar Raspadinha',
        prizeContent: 'CONTEÚDO DESSA RASPADINHA',
        congratulation: 'PARABÉNS',
        addToAccount: 'O valor será adicionado automaticamente à sua conta.',
        revealAll: 'REVELAR TUDO',
        successTip: 'Você é um vencedor, tente novamente',
        failTip: 'Você não é um vencedor, tente novamente'
    },
    RedemptionCode: {
        tips1: 'Cadastre-se no canal para receber cupons de resgate todos os dias e o dinheiro será depositado diretamente na sua conta.',
        RedemptionCode: 'Código de resgate',
        PleaseEnterTheRedemptionCode: 'Insira o código de resgate.',
        PleaseEnterTheRedemptionCode2: 'Por favor, vá ao canal do Telegram e ao canal do WhatsApp para obter.',
        exchange: 'Resgatar prêmio',
        RedemptionRecord: 'Registro de Resgate'
    },
    red_envelope: {
        ClaimNow: 'Receber prêmio',
        homepage: 'Voltar à página inicial',
        getMoney: 'Parabéns! Recebe ',
        remainder: 'Tempo restante',
        GrabRedEnvelope: 'Pega num envelope vermelho'
    },
    depositWithdraw: {
        MyAssets: 'Meus ativos',
        TotalBalance: 'Saldo total',
        WithdrawableAmount: 'Valor sacável',
        Recharge: 'Recarregar',
        Retirar: 'Sacar',
        records: 'Registros',
        RechargeAmount: 'Valor de recarga',
        ExplanationBonusEvent: 'Explicação do evento de bônus',
        MinimumDeposit: 'Depósito mínimo ',
        RechargeBonusTips: 'Recarregue de acordo com o valor recomendado para receber o bônus correspondente. O valor do bônus será acumulado junto com o valor da recarga.',
        RechargeMethods: 'Métodos de recarga',
        DepositeAhora: 'Deposite agora',

        MinimumWithdrawal: 'Saque mínimo ',
        ConfirmWithdrawal: 'Confirmar saque',

        RechargeRecords: 'Histórico de recargas',
        WithdrawalRecords: 'Histórico de saques',
        rechargeTaskTip1: 'Somente recarregando',
        rechargeTaskTip2: 'você poderá concluir a tarefa'
    },
    playGameByDeposit: {
        title: 'Recarregue para desbloquear jogos',
        desc: 'Suas recompensas exclusivas de jogo estão esperando. Ative-as imediatamente após recarregar.',
        activateNow: 'Ativar agora',
        reject: 'Recusa cruel'
    },
    notification: {
        navTitle: 'Central de mensagens',
        tabService: 'Serviço',
        tabInfo: 'Informações',
        tabNotice: 'Notificações',
        tabAnnouncement: 'Anúncios',
        serviceTitle: 'Suporte online 24/7',
        serviceDesc: 'O atendimento ao cliente está disponível para ajudar a resolver problemas e responder às suas dúvidas.',
        serviceButton: 'Suporte 24/7',
        onlineChatTitle: 'Atendimento ao cliente online',
        onlineChatDesc: 'Se precisar de ajuda, entre em contato com o atendimento ao cliente',
        service24Hours: 'Atendimento ao cliente 24 horas',
        contactNow: 'Fale conosco agora',
        officialGroupDesc: 'Entre no grupo oficial interativo do jogo para obter as informações mais recentes do jogo.',
        whatsappChannel: 'Canal oficial do WhatsApp',
        telegramChannel: 'Canal oficial do Telegram',
        instagramChannel: 'Canal oficial do Instagram',
        joinNow: 'Entre agora',
        ad1: '<p>Primeiro depósito com bônus de até <span style="color: rgb(230, 0, 0);">20%</span>! O depósito mínimo é de $20!</p>',
        ad2: '<p>Cadastre-se e baixe o aplicativo para ganhar grandes prêmios!</p>',
        ad3: '<p>Muitos privilégios ao subir para o nível <span style="color: rgb(230, 0, 0);">VIP! </span>Não se esqueça de aproveitá-los!</p>',
        ad4: '<p>Recompensa de check-in diário - quanto mais você recarregar, mais recompensas vai ganhar!</p>',
        ad5: '<p data-v-f8490b69="" class="ellipsis-1"><p>Quanto mais você recarrega, mais bônus ganha! No seu segundo depósito, receba até <span style="color: rgb(230, 0, 0);">10%</span> de bônus. Aproveite!</p></p>',
        ad6: '<p>Convide seus amigos para jogar e ganhar milhões! Ganhe <span style="color: rgb(230, 0, 0);">$35</span> por cada amigo convidado.</p>',
        ad7: '<p>Uma boa mentalidade é a arma mais crucial para o seu sucesso.</p>',
        defaultInfoTitle: 'Seu cadastro foi concluído com sucesso',
        defaultInfoContent: '<p data-v-7e100e6c=""><p>🎉 <strong>Cadastro concluído com sucesso!</strong></p><p>Bem-vindo ao <strong>XO GROUP 🎰</strong></p><p>Sua conta foi criada com sucesso - prepare-se para aproveitar os melhores jogos e ganhar grandes prêmios! 💎</p><p>👉 <strong>Faça seu primeiro depósito e receba até 20% de bônus extra.</strong> 🚀</p></p>'
    },
    weeklySalary: {
        back: 'Voltar',
        heroTitle: 'Usuários VIP, resgate suas recompensas de upgrade e salário semanal.',
        heroDesc: 'Recarregue para desbloquear recompensas generosas e receber seu bônus semanal.',
        currentLevel: 'Nível atual:',
        sectionTitle: 'Recompensas de upgrade',
        rulesHeading: 'Bônus Semanal VIP',
        rulesTitle: 'Regras do evento:',
        rule1: 'Toda semana, você receberá uma recompensa em dinheiro exclusiva com base no seu nível VIP atual.',
        rule2: 'Quanto maior o seu nível VIP, maior será o seu bônus semanal.',
        rule3: 'O bônus pode ser resgatado todas as quartas-feiras após 05:00h diretamente na sua conta.',
        rule4: 'Este evento é válido apenas para operações normais de proprietários de contas. Contas alugadas, bots, múltiplas contas, negociação artificial e arbitragem são estritamente proibidos.',
        recordButton: 'Histórico de Resgate',
        recordSubtitle: 'Histórico de bônus semanais recebidos',
        claim: 'Resgatar',
        claimed: 'Resgatado',
        claimSuccess: 'Recompensa resgatada com sucesso',
        stampFinished: 'Concluído',
        stampLocked: 'Bloqueado',
        stampAvailable: 'Disponível',
        completed: 'Concluído',
        sent: 'Enviado',
        recordEntry: 'Salário Semanal',
        levelLabelCurrent: 'Nível atual',
        levelLabelUpgrade: 'Primeiro salto VIP',
        levelLabelWeekly: 'Recompensa semanal',
        levelLabelPremium: 'Bônus premium',
        levelLabelTop: 'Salário máximo',
        navTitle: 'Salário VIP',
        tableLevel: 'Nível',
        tableUpgradeRewards: 'Recompensas de nível',
        tableWeeklySalary: 'Salários semanais',
        detailRule3: 'O bônus poderá ser resgatado toda segunda-feira após 01:00 da manhã diretamente na sua conta.',
        detailRule4: 'Este evento é limitado apenas a operações normais do titular da conta. É estritamente proibido o uso de técnicas como: contas alugadas, bots, múltiplas contas, mineração mútua, arbitragem, uso de API ou protocolos, exploração de vulnerabilidades ou controle de grupos. Caso contrário, a recompensa poderá ser cancelada ou deduzida, e a conta poderá ser congelada ou até permanentemente bloqueada.',
        detailRule5: 'Para evitar mal-entendidos na interpretação do texto, a plataforma reserva o direito final de interpretação deste evento.',
        recordNavTitle: 'Recompensas VIP',
        recordTabUpgrade: 'Recompensa de nível',
        recordTabWeekly: 'Salário semanal',
        recordTableVipLevel: 'Nível VIP',
        recordTableUpgradeAmount: 'Recompensas de atualização',
        recordTableWeeklyAmount: 'Salário',
        recordTableTime: 'Tempo',
        rescueRecordNavTitle: 'Subsídio por perdas',
        rescueRecordTabDaily: 'Pagamento De Ajuda Diária',
        rescueRecordTabWeekly: 'Pagamento De Ajuda Semanal',
        rescueRecordTableVipLevel: 'Nível VIP',
        rescueRecordTableFunds: 'Fundos de ajuda',
        rescueRecordTableTime: 'Tempo',
        upBonusTitle: 'Super recompensa',
        upBonusDesc1: 'Atualmente voce pode resgatar uma recompensa regular de',
        upBonusDesc2: 'mas ao depositar',
        upBonusDesc3: 'voce pode resgatar um super bonus de',
        upBonusSuperDouble: 'Super em dobro',
        upBonusCommon: 'Comum'
    },
    weeklyRescue: {
        navTitle: 'Subsídio por perdas',
        dailyTab: 'Pagamento De Ajuda Diária',
        weeklyTab: 'Pagamento De Ajuda Semanal',
        dailyTitle: 'O subsídio de hoje',
        weeklyTitle: 'O subsídio desta semana',
        dailyDesc: 'Poderá ser recolhido às {time} do dia seguinte.',
        weeklyDesc: 'Poderá ser recolhido na segunda-feira às {time} da manhã.',
        level: 'Nível',
        lossAmount: 'Quantidade de perda',
        subsidy: 'Subsídio',
        recordButton: 'Registro Da Coleta',
        yesterdaySubsidy: 'Subsidio de ontem',
        lastWeekSubsidy: 'Subsidio da semana passada',
        redeemSuccessTitle: 'Resgate realizado com sucesso',
        redeemSuccessMessage: 'obter {currencyType} {amount}',
        confirmButton: 'Confirmar'
    },
    socialMedia: {
        socialMedia: 'redes sociais'
    },
    claimRedEnvelope: {
        Envelope: 'Envelope',
        totalTips1: 'Deposite ',
        totalTips2: ' hoje para participar. Você depositou ',
        totalTips3: 'Aposte ',
        totalTips4: ' hoje para participar. Você colocou uma aposta de ',
        totalTips5: '.',
        totalTips6: 'O limite máximo para esta rodada de envelopes vermelhos é de ',
        totalTips7: ' vezes',
        totalTips8: 'Este é o ',
        totalTips9: 'º envelope vermelho.',
        Claimed: 'Alegou',
        late: 'atrasado',
        enter: 'Entrar',
        getSuccTitle: 'Parabéns',
        getSuccContent: 'obter',
        YouCanGet: 'Pode obter ',
        noticeLabel: 'Lista de envelopes vermelhos:',
        eventOver: 'O evento acabou',
        eventStart: 'A actividade está em curso',
        needTips1: 'Faça um depósito de {amount} hoje para resgatar esse envelope vermelho.',
        needTips2: 'Aposte {amount} hoje para resgatar esse envelope vermelho.',
        needTips3: 'Requisitos não atendidos',
        needTips4: 'Você não atende aos critérios de elegibilidade para resgatar a recompensa',
        upTips1: 'Você já pode resgatar um envelope vermelho pequeno. Deposite {upAmount} para ganhar um maior com recompensas extras.',
        upTips3: 'Deposite {amount} para resgatar um envelope vermelho pequeno; deposite {upAmount} para pegar um maior com melhores recompensas.',
        upTips6: 'Aposte {amount} para resgatar um envelope vermelho pequeno; deposite {upAmount} para ganhar um maior com recompensas mais altas.',
        upTips7: 'Resgate seu envelope vermelho de recompensa por atualização agora:',
        UpgradeRedEnvelope: 'Atualizar envelope vermelho',
        RegularRedEnvelope: 'Envelope vermelho comum',
        DepositedBalance: 'Depositado no saldo',
        redPacketTitle: 'Parabéns! Você recebeu o envelope vermelho com bônus.'
    }
}
